import api from "@/services/api";
import store from "@/store";
import { isAdmin } from "@/helpers/js/user";

export async function getTimesheetAlertClass() {
    try {
        if(isAdmin()) return "";
        const user = store.state.user;
        const configurations = store.state.configurations || {};

        if (!user) return "";

        const engineerId = user.Sort_Key;

        const now = new Date();

        const formatDate = (date) => {
            return date.getFullYear() + "-" +
                String(date.getMonth() + 1).padStart(2, "0") + "-" +
                String(date.getDate()).padStart(2, "0");
        };

        const firstDayOfWeek = 1; // Monday (keep consistent with your app)
        const startOfWeek = new Date(now);
        const diff = (now.getDay() - firstDayOfWeek + 7) % 7;
        startOfWeek.setDate(now.getDate() - diff);

        const startDate = formatDate(startOfWeek);
        const endDate = formatDate(now);

        const data = await api.request(
            "get",
            `timesheet?engineerId=${engineerId}&startDate=${startDate}&endDate=${endDate}`
        );

        const items = data.items || [];

        const isWorkingDay = (date) => {
            const day = date.getDay();

            if (day === 0 && configurations?.SundayIsWorkingDay === false) return false;
            if (day === 6 && configurations?.SaturdayIsWorkingDay === false) return false;

            return true;
        };

        const itemsMap = {};

        items.forEach(item => {
            const key = formatDate(new Date(item.Date)); // normalize API date

            if (!itemsMap[key]) itemsMap[key] = [];
            itemsMap[key].push(item);
        });

        let missingDays = 0;

        for (let d = new Date(startOfWeek); d <= now; d.setDate(d.getDate() + 1)) {
            const current = new Date(d);

            if (!isWorkingDay(current)) continue;

            const dateStr = formatDate(current);

            const dayEntries = itemsMap[dateStr] || [];

            const hasWorked = dayEntries.some(item => {
                const start = item.StartTime || "00:00";
                const finish = item.FinishTime || "00:00";
                const lunch = item.Lunch || "00:00";

                const toHours = (t) => {
                    const [h, m] = t.split(":").map(Number);
                    return h + m / 60;
                };

                const worked =
                    toHours(finish) - toHours(start) - toHours(lunch);

                return worked > 0;
            });

            if (!hasWorked) {
                const diffDays = Math.floor(
                    (now - current) / (1000 * 60 * 60 * 24)
                );                

                // only count past days (not today)
                if (diffDays >= 1) {
                    missingDays++;
                }
            }
        }

        if (missingDays >= 2) return "error-allert";   
        if (missingDays === 1) return "warning-allert";

        return "";
    } catch (err) {
        return "";
    }
}
